import { DeviceTypeOption } from 'src/app/pages/device-register/models/device-type-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { deviceTypeOptionActions } from './device-type-option.actions';

export const deviceTypeOptionFeatureKey = 'deviceTypeOptions';

export type DeviceTypeOptionState = EagerSelectState<DeviceTypeOption>;

const adapter = createEagerSelectAdapter<DeviceTypeOptionState, DeviceTypeOption>({
   featureKey: deviceTypeOptionFeatureKey,
   selectId: (device: DeviceTypeOption) => {
      return device.deviceTypeId ?? '';
   },
});

export const deviceTypeOptionSelectors = adapter.getSelectors(filterDisplayNamedOption);

const initialState = adapter.getInitialState();

export const deviceTypeOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   deviceTypeOptionActions.search,
   deviceTypeOptionActions.searchReset,
   deviceTypeOptionActions.loadFromApi,
   deviceTypeOptionActions.loadFromApiSuccess,
   deviceTypeOptionActions.loadFromApiFailure
);

export function filterDisplayNamedOption<T extends DeviceTypeOption>(
   types: T[],
   searchText: string | null | undefined
): T[] {
   if (types.length === 0) {
      return [];
   }
   const term = searchText && searchText.trim();
   if (term) {
      const upper = term.toUpperCase();
      return types.filter((item) => {
         return item.name ? item.name.toUpperCase().includes(upper) : false;
      });
   } else {
      return types || [];
   }
}
